function getDocumentHeight(): number {
  if (typeof document !== "undefined") {
    const D = document
    return Math.max(
      Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
      Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
      Math.max(D.body.clientHeight, D.documentElement.clientHeight)
    )
  }
  return 0
}

export default getDocumentHeight
